module.exports = __webpack_public_path__ + "img/red-flag.e791d9ee.svg";